import React from 'react';
import { ArrowUpRight, BarChart3, Send } from 'lucide-react';
import { Link } from 'react-router-dom';

const Mission = () => {
  return (
    <section className="container-x section" data-testid="mission">
      <div className="grid lg:grid-cols-12 gap-10 items-stretch">
        {/* Left: copy */}
        <div className="lg:col-span-6 flex flex-col justify-center">
          <span className="inline-flex items-center self-start gap-2 px-3 py-1 rounded-full bg-cream-2 border border-line text-xs font-semibold uppercase tracking-[0.2em] text-ink">
            Our approach
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-[3.5rem] font-extrabold mt-5 leading-[1.05] text-ink">
            We blend craft and{' '}
            <span className="font-serif italic text-[var(--gh-orange)]">data-driven</span>{' '}
            insights to build inboxes that pay rent.
          </h2>
          <p className="mt-6 text-lg text-muted-warm leading-relaxed">
            Every engagement starts with the boring layer — deliverability, list hygiene,
            attribution. Then we build the fun stuff: copy that sounds like you, sequences
            that feel personal, and a reporting cadence that actually changes your week.
          </p>

          <div className="mt-8 grid sm:grid-cols-2 gap-3">
            <div className="rounded-2xl bg-cream-2 border border-line p-5">
              <p className="text-xs uppercase tracking-widest text-[var(--gh-orange)] font-semibold">Our vision</p>
              <p className="mt-2 text-sm text-ink leading-relaxed">
                Become the boutique inbox studio that creators recommend without being
                asked.
              </p>
            </div>
            <div className="rounded-2xl bg-cream-2 border border-line p-5">
              <p className="text-xs uppercase tracking-widest text-[var(--gh-orange)] font-semibold">Our mission</p>
              <p className="mt-2 text-sm text-ink leading-relaxed">
                Turn every list we touch into a predictable, measurable revenue engine.
              </p>
            </div>
          </div>

          <div className="mt-8">
            <Link to="/about" className="btn-outline" data-testid="mission-learn-more">
              Learn more <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        {/* Right: collage with floating cards */}
        <div className="lg:col-span-6 relative">
          <div className="grid grid-cols-2 gap-4 h-full">
            <div className="rounded-3xl overflow-hidden h-72 sm:h-80">
              <img
                src="https://images.unsplash.com/photo-1758873268663-5a362616b5a7?w=900&q=75"
                alt="Strategy session"
                loading="lazy"
                decoding="async"
                width="900"
                height="900"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="rounded-3xl overflow-hidden mt-12 h-72 sm:h-80">
              <img
                src="https://images.unsplash.com/photo-1759752394755-1241472b589d?w=900&q=75"
                alt="Analytics dashboard"
                loading="lazy"
                decoding="async"
                width="900"
                height="900"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="col-span-2 rounded-3xl overflow-hidden h-56">
              <img
                src="https://images.unsplash.com/photo-1556761175-b413da4baf72?w=800&q=75"
                alt="Campaign launch desk"
                loading="lazy"
                decoding="async"
                width="800"
                height="492"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Floating cards on top */}
          <div className="absolute top-6 -left-4 sm:left-2 float-card px-4 py-3 w-56 animate-float-y-slow">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 rounded-lg bg-[var(--gh-orange-soft)] text-[var(--gh-orange)] flex items-center justify-center">
                <BarChart3 className="w-4 h-4" />
              </span>
              <div>
                <p className="text-[10px] uppercase tracking-widest text-muted-warm">Newsletter</p>
                <p className="text-sm font-bold text-ink leading-tight">Open rate: 87%</p>
              </div>
            </div>
            <svg viewBox="0 0 120 30" className="w-full mt-2">
              <polyline
                fill="none" stroke="var(--gh-orange)" strokeWidth="2"
                points="0,22 18,18 35,20 55,12 72,15 90,8 110,4"
                strokeLinecap="round" strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="absolute bottom-4 right-2 float-card px-4 py-3 w-60 animate-float-y">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 rounded-lg bg-ink text-[var(--gh-cream)] flex items-center justify-center">
                <Send className="w-4 h-4" />
              </span>
              <div>
                <p className="text-[10px] uppercase tracking-widest text-muted-warm">Booked</p>
                <p className="text-sm font-bold text-ink leading-tight">Strategy call · 9:30 AM</p>
              </div>
            </div>
          </div>

          {/* Total subscribers chip */}
          <div className="absolute top-1/2 -right-2 -translate-y-1/2 hidden lg:block float-card px-4 py-3 text-center">
            <p className="text-[10px] uppercase tracking-widest text-muted-warm">Total subs</p>
            <p className="font-display text-2xl font-extrabold text-ink leading-none">214,000</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
